/* eslint-disable no-param-reassign */
import Vue from 'vue';

const GoogleAnalyticsEventsHelper = {
  install(/* vue */) {
    Vue.mixin({
      methods: {
        $sendAnalyticsEvent(event) {
          try {
            if (window.gtag) {
              window.gtag('event', event);
            } else if (window.dataLayer) {
              window.dataLayer.push({
                event: event,
              });
            } else {
              console.log('send_google_event', event);
            }
          } catch (error) {
            console.log('error when sending google event', error);
          }
        },
      }
    });
  }
}

export default GoogleAnalyticsEventsHelper;
